import React, { useState } from "react";
import TitleDrawer from "@components/drawer/TitleDrawer";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: "2rem 0",
  gap: "2rem",
  justifyContent: "center",
  alignItems: "center",
}));

const TitleWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "2.4rem",
  lineHeight: "3.6rem",
  fontWeight: theme.fontWeight.bold,
}));

const ContentBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.6rem",
}));

const SubTitle = styled.div(({ theme }) => ({
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.bold,
  lineHeight: "2rem",
}));

const Item = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.4rem",

  ".title": {
    fontWeight: theme.fontWeight.medium,
    lineHeight: "2.4rem",
  },

  ".desc": {
    color: theme.color.gray,
    lineHeight: "2.4rem",
  },
}));

const Line = styled.div(({ theme }) => ({
  width: "100%",
  height: "1px",
  backgroundColor: theme.color.light_gray,
}));

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
const ConditionDrawer = ({ open, setOpen }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [noticeDrawer, setNoticeDrawer] = useState(false);

  const newArr = {
    title: "새상품 (지난 컬렉션)",
    children: [
      {
        title: "새상품",
        description: "지난 컬렉션. 착용, 사용한 적 없는 상품",
      },
      {
        title: "샘플 세일",
        description:
          "샘플로 만들었지만 상용화 되지않은 세상에 하나뿐인(일 수 있는) 상품",
      },
      {
        title: "DP 상품",
        description: "매장 내 진열했던 상품",
      },
      {
        title: "B급 새상품",
        description: "착용/사용에 문제없는 정도의 미세한 하자를 가진 새상품",
      },
    ],
  };
  const usedArr = {
    title: "중고상품",
    children: [
      {
        title: "세컨핸드 A",
        description: "택도 안 뗀, 새 것 같이 보관만 한 중고",
      },
      {
        title: "세컨핸드 B",
        description: "한 번도 입은 적 없는 중고",
      },
      {
        title: "세컨핸드 C",
        description: "좋은 컨디션 (5번 이내 착용)",
      },
      {
        title: "세컨핸드 D",
        description: "사용감 있는 중고",
      },
    ],
  };

  return (
    <TitleDrawer open={open} setOpen={setOpen} title="컨디션" closeIcon>
      <Container>
        <TitleWrapper>
          <span>{t("제품 컨디션의")}</span>
          <span>{t("종류는 이렇게 돼요")}</span>
        </TitleWrapper>

        <Image src={theme.image.phone.default} size="9.4rem" />
      </Container>

      <SubTitle>{t(newArr.title)}</SubTitle>
      {newArr.children.map((item, index) => (
        <ContentBox key={index}>
          <Item>
            <span className="title">{t(item.title)}</span>
            <span className="desc">{t(item.description)}</span>
          </Item>
        </ContentBox>
      ))}

      <Line />

      <SubTitle>{t(usedArr.title)}</SubTitle>
      {usedArr.children.map((item, index) => (
        <ContentBox key={index}>
          <Item>
            <span className="title">{t(item.title)}</span>
            <span className="desc">{t(item.description)}</span>
          </Item>
        </ContentBox>
      ))}
    </TitleDrawer>
  );
};

export default ConditionDrawer;
